import { useState } from 'react';
import {
    Grid,
    PargodaRoundButton,
    TextField,
    useTheme,
    useAppDispatch,
} from '../../../base';
import { CardWrapper } from './SendMessageBox.styles';
import { useTranslation } from 'react-i18next';
import { jobApplicationActions } from '../../../actions';

interface Props {
    onSave?: () => void;
}

const SendMessageBox = (props: Props) => {
    const { onSave } = props;
    const theme = useTheme();
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const [newMessage, setNewMessage] = useState('');

    const handleSendMessage = () => {
        if (newMessage.trim()) {
            dispatch(
                jobApplicationActions.sendChatMessage({
                    message: newMessage.trim(),
                })
            );
            setNewMessage('');
            if (onSave) {
                onSave();
            }
        }
    };

    return (
        <CardWrapper>
            <Grid container direction="column" style={{ height: '100%' }}>
                <Grid item>
                    <TextField
                        fullWidth
                        multiline
                        rows={4}
                        placeholder={t('jobApplicationPage.typeMessage')}
                        value={newMessage}
                        onChange={(e) => setNewMessage(e.target.value)}
                        variant="outlined"
                        sx={{ paddingTop: theme.spacing(1) }}
                    />
                </Grid>
                <Grid item sx={{ textAlign: 'end', paddingTop: '24px' }}>
                    <PargodaRoundButton
                        variant="outlined"
                        onClick={handleSendMessage}
                        disabled={!newMessage.trim()}
                        buttonColor={theme.palette.secondary.main}
                    >
                        {t('jobApplicationPage.sendMessageButtonLabel')}
                    </PargodaRoundButton>
                </Grid>
            </Grid>
        </CardWrapper>
    );
};

export default SendMessageBox;
